import * as React from 'react'
import styled from 'styled-components'

import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'
import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'

const ID = 'facebook-third-party-glyph-icon'

export function FacebookSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 32 32">
      <path d="M26.676,4 L5.324,4 C4.593,4 4,4.593 4,5.324 L4,26.676 C4,27.408 4.593,28 5.324,28 L16.818,28 L16.818,18.706 L13.689,18.706 L13.689,15.085 L16.818,15.085 L16.818,12.41 C16.818,9.311 18.712,7.625 21.477,7.625 C22.802,7.625 23.941,7.722 24.273,7.766 L24.273,11.006 L22.352,11.006 C20.852,11.006 20.56,11.727 20.56,12.777 L20.56,15.088 L24.144,15.088 L23.679,18.718 L20.56,18.718 L20.56,28 L26.675,28 C27.408,28 28,27.408 28,26.676 L28,5.324 C28,4.593 27.408,4 26.676,4" />
    </symbol>
  )
}

const FacebookStandaloneContent = standalone(FacebookSymbol, ID)

export const Facebook = styled(function FacebookStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-facebook">
      <FacebookStandaloneContent />
    </Icon>
  )
})``

export const FacebookLightweight = styled(function FacebookComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-facebook">
      {lightweight(ID)}
    </Icon>
  )
})``
